import { useSuspenseQueryGet } from "../../typed-client/hooks/use-suspense-query-get"

export const useRequestablePresenceShiftTypes = ({
  departmentId,
}: {
  departmentId: number
}) =>
  useSuspenseQueryGet(
    "/api/ShiftType/GetRequestablePresenceShiftTypesForDepartment",
    { departmentId },
    {
      gcTime: Infinity,
      staleTime: Infinity,
    }
  )
